import React from "react";
import BaseStepComponent from "./common/BaseStepComponent";

const Step4 = () => {
  return (
    <BaseStepComponent
      stepNumber={4}
      title="Live Call"
      videoSrc="https://contentmedius.s3.ap-south-1.amazonaws.com/part_4_live_calls_settlement_dispute.mp4"
      directLink="https://contentmedius.s3.ap-south-1.amazonaws.com/part_4_live_calls_settlement_dispute.mp4"
      nextStep={5}
    />
  );
};

export default Step4; 